export default __webpack_public_path__ + "static/media/hbrascend.d35e169e.jpeg";